import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthInformation } from './model';

export interface AuthState {
  authInformation?: AuthInformation;
}

const initialState: AuthState = {};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    updateAuthInformation(state: AuthState, action: PayloadAction<AuthInformation>) {
      state.authInformation = { ...action.payload, requestedAt: Date.now() };
    },
    removeAuthInformation(state: AuthState) {
      state.authInformation = undefined;
    },
  },
});

export const { updateAuthInformation, removeAuthInformation } = authSlice.actions;
